document.addEventListener('DOMContentLoaded', function() {
  const calculateButton = document.getElementById('calculate-button');
  if (calculateButton) {
    calculateButton.addEventListener('click', calculateQuote);
  }

  function calculateQuote() {
    try {
      const originalPrice = parseFloat(document.getElementById('original-price').value) || 0;
      if (originalPrice < 999) throw new Error("Original price must be at least $999.");
      const year = parseInt(document.getElementById('year').value) || 2023;
      const mileage = parseFloat(document.getElementById('mileage').value) || 0;
      const brandFactor = parseFloat(document.getElementById('brand').value) || 1.0;
      const condition = parseFloat(document.getElementById('condition').value) || 1.0;
      const battery = parseFloat(document.getElementById('battery').value) / 100 || 1.0;

      const age = 2025 - year; // Current year: October 19, 2025
      let depreciation = 0.3; // 30% year 1
      for (let i = 1; i < age && i < 4; i++) depreciation += 0.2; // 20% subsequent, cap at 3 years
      depreciation = Math.min(depreciation, 0.8);

      const mileageDeduct = Math.min(mileage / 10000, 0.5); // 10% per 1k miles, cap at 50%
      const batteryFactor = battery * 0.3 + 0.7; // Battery weighs 30% of value

      const value = originalPrice * (1 - depreciation) * condition * brandFactor * (1 - mileageDeduct) * batteryFactor;
      const roundedValue = Math.max(Math.round(value), 0);

      document.getElementById('quote-result').innerHTML = `Your estimated trade-in value: $${roundedValue}`;
    } catch (error) {
      document.getElementById('quote-result').innerHTML = `Error: ${error.message}`;
    }
  }
});